<template>
  <div id="wrapBox">
    <el-container id="app">
      <el-header class="header-box">
        <router-view name="headerPage" v-wechat-title="$route.meta.title"></router-view>
      </el-header>
      <el-container>
        <el-aside width="200px" class="aside-box">
          <router-view name="asidePage"></router-view>
        </el-aside>
        <el-main class="main-box" :style="containerstyle">
          <router-view name="mainPage"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
  	return {
      containerstyle:{
        "height":"0px"
      }
  	}
  },
  mounted () {
    this.init();
    this.getDictFun();
  },
  methods:{
    init() {
      const _this = this;
      const winH = document.documentElement.clientHeight || document.body.clientHeight;
      _this.containerstyle.height = winH - 60 + 'px';
    },
    //获取字典数据
    getDictFun:function(){
      var _this=this;
      _this.$axios.get('/requestApi/dict/find/dict')      
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            localStorage.setItem('dictionary',JSON.stringify(data.data));
          }else{
            _this.$message({
              message: data.meta.friendlyMsg,
              type: 'warning'
            });
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
  }
}
</script>

<style lang="less">
@bgColor:#fff;
@btnBgColor:#1989fa;
@inputBorder:solid 1px #ccc;
@border:solid 1px #c9defc;
@fonsColor:#333333;
@tableHeadBgColor:#f0f7fc;
@tableTrBgColor:#f8f9fe;
@boxBorder:solid 1px #e4e3e8;
@boxShadow:0 0 4px rgba(0,0,0,0.1);
html{height: 100%; min-width: 1400px;}
.clearfix:before,.clearfix:after{content: " ";display: table;}
.clearfix:after{clear: both;}
.clearfix{zoom:1}
body{
  margin: 0px;
  height: 100%;
  overflow: hidden;
  background-color: #f7f7f7;
  min-width: 1400px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: @fonsColor;
  height: 100%;
  min-width: 1400px;
}
.noData{display: inline-block;font-size: 13px; width: 100%;text-align: center; color: #666;}
.tishi-p{font-size: 15px;}
.red{color: #f00;}
.boldStr{font-weight: bold; margin-right: 6px;}
a{cursor: pointer;color: rgb(0, 120, 255);text-decoration: none;}
.header-box{background-color: #2855f7; border: none;}
.aside-box{ //变量名 必须使用大括号包裹
  background:linear-gradient(to bottom,#4265ed,#3c98fb);
}
.titleMarginTop{margin-top: 30px;}
.marginTop{margin-top: 20px!important;}
.el-main{padding: 20px;overflow: auto;}
//菜单样式
.el-menu-item-group__title{padding: 0px;}
.el-menu-item,.el-submenu__title{text-indent: 16%;font-size: 16px!important;}
.el-menu .is-active{background-color: #3e5ede;}
.el-menu-item:focus,.el-menu-item:hover{background-color: transparent!important; color: #fff;}
.el-submenu__title:focus,.el-submenu__title:hover{background-color: transparent!important; color: #fff;}
.el-submenu__title i{color: #a6c8ff;}
//首页
.info-box{margin-bottom: 20px;}
.info-box ul li{float: left;border: @inputBorder; margin-left: 20px;}
.info-box ul li:nth-of-type(1){margin-left: 0px;}
.info-box ul li a{display: block;padding: 12px 20px;}
.info-box ul li a .info-title{font-size: 15px; display: block;}
.info-box ul li a .info-value{font-size: 22px; display: block; margin-top: 10px; color: #000; font-weight: bold;}                             
.pad-left{padding-left: 20px;}
.select-box{ background-color: #fff;padding: 20px;box-shadow: @boxShadow;}
.result-box{ margin-top: 20px; margin-bottom: 20px;}
.result-box-title{height: 50px;line-height: 20px; font-size: 16px;}
.result-box-title p{display: inline-block;text-indent: 20px; font-size: 15px;font-weight: 700; border-left: 2px solid #1989fa; margin-top: 10px;margin-bottom: 0px;}
.result-box-title p span{color: #1989fa; margin: 0px 2px;}
.result-box-title .select-box-btn{float: right;height: 40px;line-height: 40px;font-size: 14px;}
.result-box-content{padding: 20px;background-color: #fff;box-shadow: @boxShadow;}
.item-select-box{float: left; margin-bottom: 20px; margin-right: 30px;}
.item-select-title{line-height: 30px;display: inline-block;text-align: right;font-size: 14px;}
.item-select-title-4{min-width: 80px;}
.item-select-title-6{min-width: 112px;}
.item-select-title-7{min-width: 122px;}
.item-select-title-8{min-width: 144px;}
.item-select-title-9{min-width: 160px;}
.item-select-box .el-select .el-input__inner{padding-left: 18px;padding-right: 18px;}
.el-date-editor.el-input, .el-date-editor.el-input__inner{width: 250px!important;}
.item-select-box .el-input .el-input__inner{width: 210px;}
.li-width .el-input .el-input__inner{width: 230px;}
.li-min-width .el-input .el-input__inner{width: 160px;}
.item-select-title,.item-select-content{float: left;}
.select-box-btn{display: block;border-radius: 5px;color: #fff; text-align: center;width: 100px; height: 40px;line-height: 40px;font-size: 15px;background: @btnBgColor; margin-left: 20px;}
.select-box-btn:last-child{margin-right: 0px;}
.public-box{width: 100%;border: @border;margin-top: 20px;}
.public-box:first-child{margin-top: 0px;}
.public-box-title{font-size: 16px; line-height: 50px;border-bottom: @border;text-indent: 20px;}
.public-box-content{padding: 20px;}
.info-list{width: 100%;}
.info-list li{width: 50%;float: left; margin-bottom: 14px;}
.info-list li span{display: inline-block;}
.info-list li .info-title{text-align: right;}
.info-list li .info-title-max{width: 25%;}
.second-title{font-size: 15px; line-height: 40px; margin-bottom: 20px;}
table .operation-btn{ margin-left: 10px;}
table .operation-btn:first-child{margin-left: 0px;}
.el-input__inner{border: @inputBorder;height: 30px!important; line-height: 30px!important;}
.el-input__icon,.el-date-editor .el-range-separator{line-height: 30px!important;}
.el-range-editor.el-input__inner{padding: 0px 10px!important;}
.el-slider__runway{margin: 13px 0px!important;}
.el-slider__bar{background-color: @btnBgColor;}
.el-slider__button{border: 2px solid @btnBgColor;}
// 弹出框
.el-dialog__body{padding: 20px;max-height: 560px;overflow: auto;}
.dialog-content{width: 100%;}
.el-pagination{margin-top: 12px;text-align: center;}
// 表格样式
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed{border-right:@border!important;}
.el-table td, .el-table th{padding: 10px 0px!important;}
.el-table td, .el-table th.is-leaf{border-bottom: @border!important;}
.el-table--border, .el-table--group{border: @border!important;}
.el-table{color: #333!important;box-shadow: @boxShadow;}
.el-table thead{color: #333!important;}
.el-table thead th, .el-table thead tr{background-color: @tableHeadBgColor!important;}
// .el-table tbody tr:nth-of-type(2n){background-color: @tableTrBgColor;}
.tableHead th .cell{font-weight: normal!important;}
.data-title{font-size: 16px;line-height: 50px;font-weight: bold;}
// .el-collapse-item__header{border-right: 1px solid #EBEEF5; background-color: #eef1fd;}
// 二级表格样式

.second-table thead th, .second-table thead tr{background-color: #f2f2f2;}
.second-table td, .second-table th.is-leaf{border-bottom: 1px solid #ebebeb;}
.second-table td, .second-table th{border-right: 1px solid #ebebeb;}
.second-table tbody tr:nth-of-type(2n){background-color: #fafafa;}
.el-collapse{border: none;}
.el-collapse-item__header{background-color: transparent!important;border-right: none; border-bottom: 1px solid #ddd;}

.el-collapse-item__content .el-collapse-item__header{margin-top: 6px;border: 1px solid #0f6ab4;}
.el-collapse-item__content .el-collapse-item:nth-of-type(1) .el-collapse-item__header{margin-top: 0px;}
.el-collapse-item__content{padding-bottom: 1px!important;}
.el-collapse-item__wrap{border: none;}
.el-collapse-item__header{border-bottom: 1px solid #eee;}
.api-detail{border: 1px solid #0f6ab4!important; border-top: none!important;}
.postApi .el-collapse-item__header{border: 1px solid #10a54a;}
.postApi .api-detail{border: 1px solid #10a54a!important; border-top: none!important;}
.postAndGetApi .el-collapse-item__header{border: 1px solid #d38042;}
.postAndGetApi .api-detail{border: 1px solid #d38042!important; border-top: none!important;}
.el-table .warning-row {
    background-color: #fcf6db!important;color: #409EFF;
  }
  .jv-container .jv-toggle{margin-top: 7px;}
  .el-tree-node__content{height: 40px!important;}
  .custom-tree-node .input-box .el-input__inner{ line-height: 30px;height: 30px;}
  .custom-tree-node .input-box .el-input{width: 100px; margin-top: 5px;}
  .el-table__expand-column{overflow: hidden;}

.public-table{width: 100%;box-shadow: @boxShadow;background-color: #fff;}
// .public-table tr:nth-of-type(2n){background-color: @tableTrBgColor;}
.public-table tr td{border: 1px solid #c9defc;color: #333;vertical-align: middle; line-height: 23px;padding: 12px 10px;font-size: 14px;}
.public-table tr .td-head{background-color: @tableHeadBgColor;color: #333;width: 15%;}
.public-table tr td .el-radio{line-height: 23px;}


.model-box{margin-bottom: 30px;}
.model-title{font-size: 18px; color: #333;font-weight: 700; margin-bottom: 20px;}
.model-content-title{font-size: 16px;display: block;font-weight: 700;border-left: 2px solid #333;text-indent: 6px;margin-bottom: 10px;margin-top: 20px;}
.el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--top .el-tabs__item.is-top:nth-child(2){padding-left:20px!important;}
.el-tabs--bottom .el-tabs__item.is-bottom:last-child, .el-tabs--bottom .el-tabs__item.is-top:last-child, .el-tabs--top .el-tabs__item.is-bottom:last-child, .el-tabs--top .el-tabs__item.is-top:last-child{padding-right:20px!important;}
.model-content{background-color: #fff;padding: 20px;box-shadow: @boxShadow;}
.model-content .el-table{box-shadow: none;}
.model-content-noPadding{padding: 0px;box-shadow: none;}
.model-content-noPadding>.el-tabs>.el-tabs__content{padding: 20px;padding-top: 0px;}
.model-content .el-table,.model-content .public-table{box-shadow: none;}
.model-content .el-tabs__item{border: 1px solid #c9defc!important;background-color: #fff!important;font-size: 14px!important; border-right: none!important; line-height: 36px!important;height: 36px!important;}
.model-content .el-tabs__item:last-child{border-right: 1px solid #c9defc!important;}
.el-tabs__nav-wrap::after{background: none;}
.el-tabs__item.is-active{border: 1px solid #409EFF!important; font-weight: 700!important; background-color: #409EFF!important;color: #fff!important;}
.el-tabs__active-bar{height: 0px!important;}
.el-tabs__nav-wrap::after{height: 0px!important;}
// .el-tabs__content{width: 100%;}
.el-dialog__footer{text-align: center!important;}
.el-slider{width: 200px; margin: 0px 10px;}
.item-select-box .range-box .el-input{width: 90px;}
.item-select-box .range-box .el-input .el-input__inner{width: 90px; display: inline-block;}
.range-box .range-span{display: inline-block; width: 20px;height: 30px;line-height: 30px;text-align: center;}
//图片上传
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px!important;
    height: 120px!important;
    line-height: 120px!important;
    text-align: center;
  }
  .avatar {
    width: 120px!important;
    height: 120px!important;
    display: block;
  }
  .dy-select-box .el-select{width: 260px;}
  .no-edit-table .has-gutter .el-checkbox{display: none;}
  .model-content .tab-first>.el-tabs__header{border-bottom: 1px solid #f3f3f3!important; background-color: #fcfcfc!important;}
  .model-content .tab-first>.el-tabs__header .el-tabs__item{border: none!important; line-height: 40px!important;height: 40px!important;border-right: 1px solid #f3f3f3!important;border-bottom: 1px solid #f3f3f3!important;background: transparent!important;}
  .model-content .tab-first>.el-tabs__header .el-tabs__item:last-child{border-right: 1px solid #f3f3f3!important;}
  .model-content .tab-first>.el-tabs__header .el-tabs__item.is-active{ background-color: #fff!important;color: #409EFF!important;border: none!important;border-right: 1px solid #f3f3f3!important;}

  // 数据总览
  .data-screening-box{ border: 1px solid #e4e3e8;box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);margin-top: 20px;}
  .data-screening-box:nth-of-type(1){margin-top: 0px;}
  .data-screening-title .condition-list{width: 100%;background-color: #f5f6fa;border-bottom: 1px solid #e4e3e8; }
  .data-screening-title .condition-list li{float: left;}
  .data-screening-title .el-input__inner,.data-screening-title input{background-color:  transparent!important;}
  .data-screening-title .condition-list li .el-date-editor--daterange{width: auto!important;}
  .data-screening-title .el-date-editor .el-range-input{width: 100px!important;}
  .data-screening-title .el-range__close-icon{display: none;}
  .data-screening-title .el-input__inner,.data-screening-title .el-range-separator{height: 40px!important;line-height: 40px!important;}
  .data-screening-title .el-input__inner{border-radius: 0px!important;border: none!important;border-right: solid 1px #e4e3e8!important;}
  .data-screening-content{padding: 20px;background-color: #fff;}
  .data-screening-content-np{padding: 0px;}
  #infoPic{width: 100%;height: 500px;}
  .data-screening-content .el-tabs__header{background-color: #f5f6fa; border-bottom: 1px solid #e4e3e8;}
  // 登录
  .login-box .el-input__inner{height: 54px!important; line-height: 54px!important; border: none!important;border-bottom: 1px solid #979797!important;border-radius: 0!important;}
  .login-box .el-input{font-size: 16px;}
  .login-box input:-webkit-autofill { box-shadow: 0 0 0px 1000px #FFF inset !important;}

  .login-btn .el-button--primary.is-disabled, .login-btn .el-button--primary.is-disabled:active, .login-btn .el-button--primary.is-disabled:focus, .login-btn .el-button--primary.is-disabled:hover{
    background: -webkit-linear-gradient(left,#b0dfff, #7da2ff)!important; /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(left,#b0dfff, #7da2ff)!important; /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(left,#b0dfff, #7da2ff)!important; /* Firefox 3.6 - 15 */
    background: linear-gradient(left,#b0dfff, #7da2ff)!important; /* 标准的语法 */
  }
  .login-btn button{
    background: -webkit-linear-gradient(left,#61beff, #346dff)!important; /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(left,#61beff, #346dff)!important; /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(left,#61beff, #346dff)!important; /* Firefox 3.6 - 15 */
    background: linear-gradient(left,#61beff, #346dff)!important; /* 标准的语法 */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue